import Papa from 'papaparse';

export function parseCsvData(csvData){
    var strucData = Papa.parse(csvData, {header: true, skipEmptyLines: true});
    return strucData;
}